export default __webpack_public_path__ + "static/media/regard_brulant.8e8e0373.jpg";